/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The resource\'s environment: production, internal production, or staging. `ENVIRONMENT_UNSPECIFIED` is supported only in responses. 
*/
export enum Environment {
  Prod = 'PROD',
  ProdInternal = 'PROD_INTERNAL',
  Stage = 'STAGE',
  EnvironmentUnspecified = 'ENVIRONMENT_UNSPECIFIED'
}
